import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';


import {environment} from '../../../../enviroments/enviroment';
import {Usuario} from '../models/usuario';
import {AuthService} from '../../../core/services/auth/auth.service';

@Injectable({
  providedIn:'root'
})
export class UsuarioService {
  private urlEndPoint = environment.urlEndPoint + '/api/usuario';
  private urlEndPointAdmin = environment.urlEndPoint + '/api/usuario-admin';
  private httpHeaders = new HttpHeaders({'Content-type': 'application/json'});

  constructor(private http: HttpClient,
              private loginService: AuthService) {
  }

  findByUsuario(codigoUsuario: string): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.urlEndPoint}?username=${codigoUsuario}`);
  }

  findAll(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlEndPoint}/all`);
  }

  //Modificar
  update(usuario: Usuario): Observable<Usuario> {
    return this.http.put<Usuario>(`${this.urlEndPointAdmin}`, usuario, {headers: this.httpHeaders});
  }

  //Modificar
  create(usuario: Usuario): Observable<Usuario> {
    return this.http.post<Usuario>(`${this.urlEndPointAdmin}`, usuario, {headers: this.httpHeaders});
  }

  //Modificar
  deleted(usuario: Usuario): Observable<Boolean> {
    return this.http.put<Boolean>(`${this.urlEndPointAdmin}/eliminar`, usuario, {headers: this.httpHeaders});
  }

  getUsuarios(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${this.urlEndPoint}s?page=${page}&&size=${size}`);
  }

  findAllByPerfilCodigo(perfil: String): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlEndPoint}/perfil?perfil=${perfil}`);
  }

  getUsuariosPorPeriodoCumplimiento(idAno: number, idMes: number): Observable<any> {
    return this.http.get<any>(`${this.urlEndPoint}s-por-periodo-cumplimiento?idAno=${idAno}&&idMes=${idMes}`);
  }
}
